var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    class: ["busi-card", {
      "dark-bg": _vm.dark
    }],
    style: {
      width: _vm.cardWidth,
      height: _vm.cardHeight
    }
  }, [_c("div", {
    staticClass: "card-top"
  }, [_c("img", {
    attrs: {
      src: _vm.img,
      alt: "image"
    }
  })]), _c("div", {
    staticClass: "card-content"
  }, [_c("h4", [_vm._v(_vm._s(_vm.title))]), _c("p", [_vm._v(_vm._s(_vm.desc))])]), _c("img", {
    staticClass: "busi-card_bg",
    style: {
      width: _vm.cardWidth
    },
    attrs: {
      src: require("@/assets/images/components/translation-app-bg.png"),
      alt: "translation-app-bg"
    }
  })]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };